var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.hasContent)?_c('div',{ref:"ad",staticClass:"max-w-full mx-auto",class:_vm.classOverride,attrs:{"width":_vm.adWidth,"height":_vm.adHeight},domProps:{"innerHTML":_vm._s(_vm.observedContent)},on:{"click":function($event){return _vm.adClicked()}}}):_c('div',[_c('LoadingSpinner',{staticClass:"w-full h-24 text-gray-300"})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }